export default {
  infoTxt: 'After this step you can choose a Jobseeker, Hirer or Referrer profile',
  titleTxt: 'Signup',
  emailTitle: 'An email is on its way!',
  signupType: 'Signup type',
  jobseekerReferrerOption: 'Jobseeker / Referrer',
  hirerOption: 'Hirer',
  labelFirstname: 'First name',
  labelLastname: 'Last name',
  labelEmail: 'Email',
  submitBtnText: 'SIGNUP',
  agreeText: 'By clicking signup you agree to the',
  hvUserTermLinkText: 'HireVibes User Terms',
  eosUserAgreementLinkText: 'EOS User Agreement',
  emailError: 'Invalid email',
  subtitleJobseeker: 'Jobseeker',
  subtitleHirer: 'Hirer',
  subtitleReferrer: 'Referrer',
  subtitleCharity: 'Charity',
  faqHirer: 'Interested in filling an opening via HireVibes? Contact our team using our chat widget or mail us directly at <a href="mailto:hello@hirevibes.io">hello@hirevibes.io</a> and we’ll be in touch immediately.',
  faqJobseeker: 'Create a profile in less than two minutes and browse for jobs that match your requirements. If you get hired, you’ll receive a tasty bonus in three instalments.',
  faqReferrer: 'Sign up as a Referrer and start referring great friends to jobs listed on HireVibes. If your referred friend get’s hired, you’ll be updated and will be sent a tasty referral bonus too!',
  faqCharity: 'Contact our customer support team on <a href="mailto:hello@hirevibes.io">hello@hirevibes.io</a>',
  faqNeedMoreHelp: 'For more FAQ, see our website <a href="https://www.hirevibes.io/faq">https://www.hirevibes.io/faq</a> or contact our team on <a href="mailto:hello@hirevibes.io">hello@hirevibes.io</a>',
  thisWillSignal: 'This will signal you’re open to consider job opportunities in these ecosystems. You can opt-out at any time.',
  joinEcosystem: 'Join ecosystem talent pools',
  jobBoard: 'Jobs board member:',
  reminder: 'Your company Bio is missing',
  updateCompany: 'Update company Profile',
  yourCompany: 'Your company profile doesn’t not have a biography description. Please update your company profile so people can know a little more about you.',
  delete: 'Delete',
  areYouSureYou: 'Areyou sure you want to delete your resume? You will have to attach a new one when you apply for jobs.'
}



// WEBPACK FOOTER //
// ./src/i18n/es/signup.js